import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./clientTheme.css";
import "./ScrollToTopButton.css";

function ArrowUpIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </svg>
  );
}

export default function ScrollToTopButton({ threshold = 400 }) {
  const { t } = useTranslation("scrollToTopButton");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setVisible(window.scrollY > threshold);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  if (!visible) return null;

  return (
    <button
      type="button"
      className="client-scroll-top-btn"
      onClick={scrollToTop}
      aria-label={t("scrollToTop")}
    >
      <ArrowUpIcon />
    </button>
  );
}
